import { inject, Injectable } from '@angular/core';
import { select, Store } from '@ngxs/store';
import { MatterMortgageFormTemplatesState } from '../../state/matter/matter_mortgages/matter-mortgage-forms/matter-mortgage-form-templates.state';
import { Logger } from '../../core/logger';
import { TagsSelector } from '../../state/global/tags/tags.selector';
import { firstValueFrom } from 'rxjs';
import { FormInstance, GlobalFormTemplate } from '@models/global-forms';
import { GlobalFormsVersionsRepo } from '../../repos/global-forms-versions.ts/global-forms-verisons.repo';
import { GlobalFormsPdfService } from '../pdf/global-forms-pdf.service';
import { GenericFormsTemplatesState } from '../../state/generic-forms';

@Injectable({ providedIn: 'root' })
export class MatterFormService {
	private matterMortgageFormTemplates_ = select(
		MatterMortgageFormTemplatesState.getMortgageFormTemplateById,
	);
	genericFormTemplates_ = select(
		GenericFormsTemplatesState.getGenericFormTemplates,
	);
	private store = inject(Store);
	private globalFormsPdfService = inject(GlobalFormsPdfService);
	private globalFormsVersionRepo = inject(GlobalFormsVersionsRepo);

	getMatterFormInstance = async (formId: string): Promise<FormInstance> => {
		let form: GlobalFormTemplate = this.matterMortgageFormTemplates_()(formId);
		if (!form) {
			form = this.genericFormTemplates_().find((f) => f.id === formId);
		}
		if (!form) {
			Logger.error(`Form with id ${formId} not found`);
			return;
		}

		const version = await firstValueFrom(
			this.globalFormsVersionRepo.Get$(form.currentVersion, {
				globalFormId: formId,
			}),
		);
		const context = await this.globalFormsPdfService.evalExpression(
			'context',
			form?.context,
			this.store.selectSnapshot(TagsSelector.getTags),
			form,
			null,
		);

		const fields = await this.globalFormsPdfService.evaluateFields(
			Object.values(version?.fieldMappings ?? {}),
			context,
		);

		const formInstance: FormInstance = {
			...form,
			storageRefPath: version.storageRefPath,
			barcodeStorageRefPath: version.barcodeStorageRefPath,
			fields,
			context: Array.isArray(context) ? context[0] : context,
		};
		return formInstance;
	};
}
